import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import { serviziApi } from "../../features/api/admin/ServiziApi";
import { adminAccount } from "../../features/api/admin/adminAccount";
import { adminCompany } from "../../features/api/admin/adminCompany";
import { adminFolderApi } from "../../features/api/admin/adminFolders";
import { aiPromptApi } from "../../features/api/admin/aiPromptApi";
import { otherServicesApi } from "../../features/api/admin/altriServiziApi";
import { assistenteSmartApi } from "../../features/api/admin/assistenteSmartApi";
import { adminAuth } from "../../features/api/admin/authApi";
import { adminCategoriesApi } from "../../features/api/admin/categoriesApi";
import { chatbotApi } from "../../features/api/admin/chatbotApi";
import { adminDashboardApi } from "../../features/api/admin/dashboardApi";
import { managementNewsApi } from "../../features/api/admin/gestioneNewsApi";
import { adminCommercialistiApi } from "../../features/api/admin/gestisciCommercialistiApi";
import { adminDocumentsApi } from "../../features/api/admin/gestisciDocumentiApi";
import { adminPracticesApi } from "../../features/api/admin/gestisciPraticheApi";
import { adminStudioApi } from "../../features/api/admin/gestisciStudioApi";
import { adminUsersApi } from "../../features/api/admin/gestisciUtentiApi";
import { magicViewApi } from "../../features/api/admin/magicViewApi";
import { adminNewsApi } from "../../features/api/admin/newsApi";
import { notificationAdminApi } from "../../features/api/admin/notificationAdmin";
import { notificheApi } from "../../features/api/admin/notificheApi";
import { practiceTaskApi } from "../../features/api/admin/practiceTaskApi";
import { rolesApi } from "../../features/api/admin/rolesApi";
import { serviceTaskApi } from "../../features/api/admin/serviceTaskApi";
import listenerMiddleware from "../../features/api/unauthorizedInterceptor";
import { userOtherServicesApi } from "../../features/api/user/altriServiziApi";
import { userAssistenteSmartApi } from "../../features/api/user/assistenteSmartApi";
import { userStudioApi } from "../../features/api/user/associaStudioApi";
import { userCalendarApi } from "../../features/api/user/calendarApi";
import { userCategoriesApi } from "../../features/api/user/categoriesApi";
import { userDocumentsApi } from "../../features/api/user/gestisciDocumentiApi";
import { userPracticesApi } from "../../features/api/user/gestisciPraticheApi";
import { userProfileApi } from "../../features/api/user/modificaProfiloApi";
import { userNewsApi } from "../../features/api/user/newsApi";
import { notificationUserApi } from "../../features/api/user/notificationUserApi";
import { openBoxApi } from "../../features/api/user/openBoxApi";
import { userPracticeServicesApi } from "../../features/api/user/servicesStudioApi";
import { tenatApi } from "../../features/api/user/tenantApi";
import { userAccount } from "../../features/api/user/userAccount";
import { userDashboardApi } from "../../features/api/user/userDashboardApi";
import { userFolders } from "../../features/api/user/userFolders";
import rootReducer from "./rootReducer";

//To use a different storage engine, we just need to modify the value of
//the storage property of persistConfig with the storage engine we want to use.
const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ["app"],
};

//https://redux-toolkit.js.org/api/getDefaultMiddleware
const middleware = [
  thunk,
  listenerMiddleware.middleware,

  //USER API
  userDashboardApi.middleware,
  userOtherServicesApi.middleware,
  userDocumentsApi.middleware,
  userNewsApi.middleware,
  userPracticesApi.middleware,
  userPracticeServicesApi.middleware,
  userProfileApi.middleware,
  userCategoriesApi.middleware,
  userAccount.middleware,
  userAssistenteSmartApi.middleware,
  userCalendarApi.middleware,
  userFolders.middleware,
  notificationUserApi.middleware,
  openBoxApi.middleware,
  tenatApi.middleware,

  //ADMIN API
  adminDocumentsApi.middleware,
  adminDashboardApi.middleware,
  otherServicesApi.middleware,
  serviziApi.middleware,
  adminCommercialistiApi.middleware,
  adminUsersApi.middleware,
  adminPracticesApi.middleware,
  adminCategoriesApi.middleware,
  adminAccount.middleware,
  notificheApi.middleware,
  assistenteSmartApi.middleware,
  adminAuth.middleware,
  managementNewsApi.middleware,
  userStudioApi.middleware,
  adminNewsApi.middleware,
  magicViewApi.middleware,
  adminStudioApi.middleware,
  adminCompany.middleware,
  chatbotApi.middleware,
  adminFolderApi.middleware,
  aiPromptApi.middleware,
  rolesApi.middleware,
  notificationAdminApi.middleware,
  serviceTaskApi.middleware,
  practiceTaskApi.middleware,
];

//enhanced reducer with configuration to persist the rootReducer state to local storage.
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: middleware,
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
